import { render, staticRenderFns } from "./timeblock.vue?vue&type=template&id=54929d15&scoped=true&"
import script from "./timeblock.vue?vue&type=script&lang=js&"
export * from "./timeblock.vue?vue&type=script&lang=js&"
import style0 from "./timeblock.vue?vue&type=style&index=0&id=54929d15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54929d15",
  null
  
)

export default component.exports